class FileListController {
  /* @ngInject */
  constructor($http, $window, Session, urls) {
    this.$http = $http;
    this.$window = $window;
    this.urls = urls;
    this.Session = Session;
  }

  $onInit() {

  }

  download(file) {
    if (this.onDownload) this.onDownload({ file });
    else if (file.id) {
      this.$window.open(
        `${this.urls.API_SERVER}/api/caseResponse/${file.case_response_id}/attachment/${
            file.id}?access_token=${this.Session.accessToken}`,
        '_blank'
      );
    }
  }

  remove() {
    this.files = undefined;
  }

  removeMultiple(index) {
    this.files.splice(index, 1);

    if (!this.files.length) this.files = undefined;
  }
}

export default FileListController;



// WEBPACK FOOTER //
// ./client/components/file-list/file-list.controller.js